document.addEventListener("DOMContentLoaded", function () {
 
    function initArtistReviews() {
 
        const wrapper = document.getElementById("artist-review-wrapper");
 
        if (!wrapper) return;
 
        const cards = document.querySelectorAll(".jdgm-carousel-item");
 
        if (cards.length === 0) {
            // Judge.me hasn't rendered yet
            setTimeout(initArtistReviews, 500);
            return;
        }
 
        wrapper.innerHTML = "";
 
        cards.forEach(function(card){
 
            const text =
            card.querySelector(".jdgm-text")?.innerHTML || "";
 
            const reviewer =
            card.querySelector(".jdgm-reviewer-name")?.textContent || "";
 
            const product =
            card.querySelector(".jdgm-product-name")?.innerHTML || "";
 
            const verified =
            card.querySelector(".jdgm-reviewer-verified-text")?.textContent || "Verified";
 
            wrapper.insertAdjacentHTML("beforeend",`
 
                <div class="swiper-slide">
                            <div class="artist-review-card">
                            <div class="artist-review-quote">
                            <i class="fas fa-quote-right"></i>
                            </div>
                            <div class="artist-review-text">
                                                        ${text}
                            </div>
                            <div class="artist-review-card-a">
                                <div class="artist-review-stars-card">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                </div>
                            <div class="artist-review-name">
                                                            ${reviewer}
                                                            ${
                                                                verified
                                                                ? `<span class="artist-review-verified">${verified}</span>`
                                                                : ""
                                                            }
                            </div>
                            </div>
                            <div class="artist-review-product">
                                                        ${product}
                            </div>
                            </div>
                            </div>
 
                            `);
 
        });
        new Swiper(".artist-review-slider",{
            slidesPerView:1,
            spaceBetween:30,
            loop:true,
            navigation:{
                nextEl:".artist-next",
                prevEl:".artist-prev"
            },
            breakpoints:{
                767:{
                    slidesPerView:2
                }
            }
        });
 
    }
 
    initArtistReviews();
 
});